<template>
    <svg class="h-5 w-5 no-color" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
    <path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 18H9.25a5.25 5.25 0 110-10.5H19M16.5 4L20 7.5 16.5 11"/>
    </svg>
</template>

<script>
export default {
  name: 'redoIcon'
}
</script>
